<template>
  <div id="page-details" class="mh-5">
      <FDO-form
          v-model="model"
          ref="form"
          :facility-id="$route.params.id"
          :card-title="`FDO: ${ model.FDODescription }`"
          readonly
      />

    <vs-alert
        color="danger"
        :title="entity + ' Not Found'"
        :active.sync="not_found"
    >
      <span>Record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span
        ><router-link :to="listRoute" class="text-inherit underline"
      >All {{ entity }}s</router-link
      >
      </span>
    </vs-alert>

    <vue-element-loading v-if="loading" :active="loading"/>

    <div class="vx-row" v-if="model && model.id">
      <div class="vx-col sm:w-1/3">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button @click="goToList" class="mt-2"> Back </vs-button>
          <vs-button
              v-if="model"
              class="mt-2 ml-4"
              color="light"
              @click="openEnableAlert(model)"
          >
            {{ model.IsEnabled ? "Deactivate" : "Activate" }}
          </vs-button>
          <slot name="extra-button" v-bind:model="model"></slot>
        </div>
      </div>
      <div class="vx-col sm:w-2/3">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              v-if="
              !isDeleted &&
              componentAccess.canDelete &&
              componentAccess.canDelete.access
            "
              @click="confirmDelete"
              class="mr-4 mt-2"
              :disabled="loading"
          >
            Delete
          </vs-button>
          <vs-button
              v-if="
              !isDeleted &&
              componentAccess.canEdit &&
              componentAccess.canEdit.access
            "
              @click="goToEdit"
              class="mt-2"
              color="light"
              :disabled="loading"
          >
            Edit
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import FDOForm from '@/views/pages/facilities/fdos/FDOForm';
import ViewPage from '../../../components/Views/ViewPage';
import CanAccessMixin from '../../../../components/mixins/CanAccessMixin';
import ViewModelMixin from '../../../../components/mixins/ViewModelMixin';
import EnablePublishMixin
  from '../../../../components/mixins/EnablePublishMixin';

export default {
  name: "FDOView",
  components: {
    FDOForm,
    ViewPage,
  },
  mixins: [NotificationMixin, ViewModelMixin, CanAccessMixin, EnablePublishMixin],
  data() {
    return {
      readonly: true,
      modelEntity: this.$api.facilities.fdos,
      baseRoute: 'facilities.fdos',
      entity: 'FDO',
      confirmedUnderwriters: false,
      existingUnderwriters: [],
      componentAccess: {
        canEdit: {
          route: 'facilities.fdos.edit',
          access: false
        },
        canDelete: {
          route: 'facilities.fdos.delete',
          access: false
        }
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.fdoId;
    },
    listRoute() {
      return { name: this.baseRoute + '.list' };
    }
  },
  methods: {
    goToList() {
      this.$router.push(this.listRoute);
    },
    goToEdit() {
      this.$router.push({ name: this.baseRoute + '.edit' });
    },
    confirmDelete() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete this Facility`,
        accept: this.deleteAction,
        acceptText: 'Delete'
      });
    },
    async deleteAction() {
      try {
        await this.modelEntity.delete(this.id);
        this.$vs.notify({
          color: 'success',
          title: this.entity + ' Deleted',
          text: this.entity + ' was successfully deleted',
          position: 'top-right'
        });
        this.goToList();
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          color: 'danger',
          title: this.entity + ' failed to delete',
          position: 'top-right'
        });
      }
    },
    setPageTitle(params) {
      if (!params.FDODescription) {
        return '';
      }

      return `FDO: ${ params.FDODescription || '' }`;
    },
    async fetch(id) {
      try {
        const {data} = await this.modelEntity.get(id);

        const fdo = data.data;
        fdo.underwriters = fdo.insurer_securities.map((underwriter) => {
          // Map the sections to our own format
          underwriter.sections = underwriter.sections.map((section) => ({
            InsurerSectionReference: section.reference.InsurerSectionReference,
            Section_FK: Number(section.reference.Section_FK),
            Section: section.Section,
          }))

          return underwriter;
        });

        // We don't need this as we overwrite it with underwriters
        delete fdo.insurer_securities;

        this.model = fdo;
        this.existingUnderwriters = fdo.underwriters.map(({FDO_PK}) => FDO_PK);
      } catch (e) {
        console.error(e)
      } finally {
        if (!this.model) {
          this.not_found = true
        }
      }
    },
  },
};
</script>

<style scoped>

</style>
